 
<template>
  <!-- 战团管理-站团列表-编辑战团 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="编辑战团"
      width="400px"
      @close="closeDialog"
    >
      <el-form :model="formData" ref="formData" label-width="80px" size="small">
        <el-form-item prop="name" label="战团名称">
          <el-input v-model="formData.name"> </el-input>
        </el-form-item>
        <el-form-item prop="contentText" label="宗旨内容">
          <el-input
            type="textarea"
            maxlength="100"
            :rows="6"
            show-word-limit
            v-model="formData.aim"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {
        id: undefined,
        name: undefined,
        aim: undefined
      }
    }
  },
  computed: {
    ...mapState({
    }),
    showMark: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfos: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    showMark(val) {
      if (val) {
        this.formData.id = this.dialogInfos.id
        this.formData.name = this.dialogInfos.name
        this.formData.aim = this.dialogInfos.aim
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.formData
      patchApiData(`team/${this.formData.id}`, params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.$emit('refresh')
          this.closeDialog()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>